var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42426 8.57574C9.18995 8.34142 8.81005 8.34142 8.57574 8.57574C8.34142 8.81005 8.34142 9.18995 8.57574 9.42426L9.42426 8.57574ZM12.5757 13.4243C12.8101 13.6586 13.1899 13.6586 13.4243 13.4243C13.6586 13.1899 13.6586 12.8101 13.4243 12.5757L12.5757 13.4243ZM5.66667 9.73333C3.42071 9.73333 1.6 7.91262 1.6 5.66667H0.4C0.4 8.57537 2.75797 10.9333 5.66667 10.9333V9.73333ZM1.6 5.66667C1.6 3.42071 3.42071 1.6 5.66667 1.6V0.4C2.75797 0.4 0.4 2.75797 0.4 5.66667H1.6ZM5.66667 1.6C7.91262 1.6 9.73333 3.42071 9.73333 5.66667H10.9333C10.9333 2.75797 8.57537 0.4 5.66667 0.4V1.6ZM9.73333 5.66667C9.73333 7.91262 7.91262 9.73333 5.66667 9.73333V10.9333C8.57537 10.9333 10.9333 8.57537 10.9333 5.66667H9.73333ZM8.57574 9.42426L12.5757 13.4243L13.4243 12.5757L9.42426 8.57574L8.57574 9.42426Z",
    fill: "#9193A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b79eb4f8865d750367638db2fbe2ad13.svg";
export { ForwardRef as ReactComponent };